import { render } from "./WeeklyContent.vue?vue&type=template&id=044d17fd&scoped=true"
import script from "./WeeklyContent.vue?vue&type=script&lang=js"
export * from "./WeeklyContent.vue?vue&type=script&lang=js"

import "./WeeklyContent.vue?vue&type=style&index=0&id=044d17fd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-044d17fd"]])

export default __exports__